module.exports = __webpack_public_path__ + "assets/retina_TriangleBySidesDetailed.acbe4dcd01cc1e47be75a0ce2db857a5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/png/levels/2x/retina_TriangleBySidesDetailed.png
// module id = 750
// module chunks = 0